module.exports = __webpack_public_path__ + "hbomaxar-static/media/LiquidTrip_OpenLoop_00204.73fec88c.png";